export function trunc(string: string, n: number): string {
    if (!string) return '';
    return string.length > n ? `${string.substr(0, n - 1)}...` : string;
}
